<template>
    <b-modal
        id="add-all-copy-portfolio-category-modal"
        ref="add-all-copy-portfolio-category-modal"
        :title="$t('portfolio.add_category')"
        :ok-title="$t('common.save')"
        @ok="onOk"
        @show="onShow"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal">
        <!--        selecteer een school-->
        <div>
            <b-form-group :label="$t('portfolio.select_school')">
                <design-2021-apprentice-multiselect-component
                    id="copy-school-select"
                    :multiple-select="false"
                    :options="schools"
                    label="name"
                    :placeholder="$t('portfolio.select_school')"
                    @input="changeSelectedSchool($event)"></design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>

        <!--        selecteer een group-->
        <div v-if="groups.length">
            <b-form-group :label="$t('portfolio.select_project')">
                <design-2021-apprentice-multiselect-component
                    id="copy-group-select"
                    :multiple-select="false"
                    :options="groups"
                    label="name"
                    :placeholder="$t('portfolio.select_project')"
                    @input="changeSelectedGroup($event)"></design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>

        <!--        selecteer een categorie-->
        <div v-if="categories.length">
            <b-form-group :label="$t('portfolio.select_category')">
                <design-2021-apprentice-multiselect-component
                    id="copy-category-select"
                    v-model="selectedCategory"
                    :multiple-select="false"
                    :options="categories"
                    label="name"
                    :placeholder="$t('portfolio.select_category')"></design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-add-all-copy-category-modal-component',
    props: {
        portfolioIn: Object,
        groupId: Number
    },
    data() {
        return {
            schools: [],
            selectedSchool: null,
            groups: [],
            selectedGroup: null,
            categories: [],
            selectedCategory: null,
        };
    },
    methods: {
        changeSelectedSchool(selectedSchool) {
            this.selectedSchool = selectedSchool;
            this.groups = selectedSchool.groups;
        },

        changeSelectedGroup(selectedGroup) {
            this.selectedGroup = selectedGroup;
            this.categories = selectedGroup.portfolios[0].categories;
        },

        onOk() {
            this.alert.saving();
            const data = {
                group_id: this.groupId,
            };
            this.axios.post(this.routes.copyAllCategory(this.selectedCategory.id, this.portfolioIn.id), data).then(
                (response) => {
                    this.portfolioIn.categories.push(response.data);
                    this.$emit('update-selected-category', response.data.id);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.schools = [];
            this.selectedSchool = null;
            this.groups = [];
            this.selectedGroup = null;
            this.categories = [];
            this.selectedCategory = null;

            this.alert.loading();

            this.axios.get(this.routes.portfolioCategorySchools()).then(
                (response) => {
                    this.alert.loaded();
                    this.schools = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
